var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{class:_vm.margin},[_vm._v(_vm._s(_vm.title))]),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }